// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__-yhL_","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2VirV","obliqueLine":"membershipbadge_obliqueLine__29kiu"};